import React, { Fragment, useState, useEffect } from 'react';
import { wsFindBy } from 'services/WService.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';

import styles from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js';

// material-ui icons
import { Assignment, Edit } from '@material-ui/icons';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Add, Business } from '@material-ui/icons';

import { wsUpdate, wsGetAll } from 'services/WService';
import { WithApp } from 'contexts/appContext';

import { useModal } from 'hooks/useModal';
import AddressModal from './Modal/Address/AddressModal';
import BusinessTurnModal from './Modal/BusinessTurnModal';
import AddresModalProvider from './Modal/Address/AddresModalProvider';
import GridContainer from 'components/Grid/GridContainer';
import { LayerProvider } from 'contexts/layerContext';

const StyleTable = {
  table: {
    minWidth: 1350,
  },
};

const useStyles = makeStyles(styles);
const useStyleTable = makeStyles(StyleTable);

export default WithApp(function Address(props) {
  const classes = useStyles();
  const claseTable = useStyleTable();
  const showNotify = props.showNotify;

  const bPartner = props.businessPartner;
  const [addresses, setAddresses] = useState([]);
  const [layers, setLayers] = useState([]);
  const [addressId, setAddressId] = useState();
  const [showModal, setShowModal] = useState(false); //Abrir modal
  const [model, setOpen] = useModal(); //uso de las funciones del modal

  const [showModalBTurn, setShowModalBTurn] = useState(false); //Abrir modal bTurn

  async function listAddress() {
    let response = await wsFindBy('base/address', 'base_business_partner_id', bPartner.id);
    if (response.success) {
      setAddresses(response.data);
    }
  }

  async function listLayers() {
    let res = await wsGetAll('base/layer');
    if (res.success) setLayers(res.data);
  }

  async function updateDefaultAddress(data) {
    let response = await wsUpdate('base/business-partner', bPartner.id, data);

    // TODO Falta usar TOASTY
    if (response.success) {
      showNotify(response.message);
      props.reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listAddress();
    listLayers();
  }, []);

  return (
    <LayerProvider>
      <GridItem xs={12}>
        <GridContainer>
          <GridItem xs={5} styles={{ marginLeft: '100px' }}>
            <AllowedGuard
              permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_STORE}
              component={
                <>
                  <p>Dirección Fiscal por defecto</p>
                  <b>{addresses.find((item) => bPartner.BillToDef == item.Address)?.Address2}</b>
                </>
              }
            >
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Dirección Fiscal por defecto</InputLabel>
                <Select
                  value={
                    addresses.find((item) => bPartner.BillToDef == item.Address)?.Address || ''
                  }
                  inputProps={{
                    name: 'BillToDef',
                    onChange: (e) => updateDefaultAddress({ BillToDef: e.target.value }),
                  }}
                >
                  {addresses
                    .filter((address) => address.AdresType === 'B')
                    .map((item, i) => {
                      return (
                        <MenuItem value={item.Address} key={i}>
                          {item.Address2}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </AllowedGuard>
          </GridItem>
          {bPartner.CardType === 'C' ? (
            <GridItem xs={5}>
              <AllowedGuard
                permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_STORE}
                component={
                  <>
                    <p>Dirección Entrega por defecto</p>
                    <b>{addresses.find((item) => bPartner.ShipToDef == item.Address)?.Address2}</b>
                  </>
                }
              >
                <FormControl fullWidth margin="normal" size="small">
                  <InputLabel>Dirección Entrega por defecto</InputLabel>
                  <Select
                    value={
                      addresses.find((item) => bPartner.ShipToDef == item.Address)?.Address || ''
                    }
                    inputProps={{
                      name: 'ShipToDef',
                      onChange: (e) => updateDefaultAddress({ ShipToDef: e.target.value }),
                    }}
                    disabled={
                      !!ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE ? false : true
                    }
                  >
                    {addresses
                      .filter((address) => address.AdresType === 'S')
                      .map((item, i) => {
                        return (
                          <MenuItem value={item.Address} key={i}>
                            {item.Address2}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </AllowedGuard>
            </GridItem>
          ) : undefined}
        </GridContainer>
      </GridItem>

      <GridItem xs={12}>
        {showModal ? (
          <AddressModal
            open={showModal}
            setOpen={setShowModal}
            addressId={addressId}
            bPartner={bPartner}
            reload={listAddress}
            showNotify={showNotify}
            layers={layers}
          />
        ) : undefined}
        <AddresModalProvider
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={listAddress}
          bPartnerId={bPartner.id}
        />
        <BusinessTurnModal
          close={setShowModalBTurn}
          open={showModalBTurn}
          addressId={addressId}
          bPartner={bPartner}
          showNotify={showNotify}
        />
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_STORE}
              component={
                <CardIcon color="primary">
                  <Assignment style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
                onClick={() => {
                  if (bPartner.CardType === 'C') {
                    setAddressId(undefined);
                    setShowModal(true);
                  } else {
                    setOpen({});
                  }
                }}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Direcciones</h4>
          </CardHeader>
          <CardBody>
            <TableContainer component={Paper}>
              <Table className={claseTable.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>ID domicilio</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Dirección</TableCell>
                    <TableCell>Ubigeo</TableCell>
                    <TableCell>Departamento</TableCell>
                    <TableCell>Provincia</TableCell>
                    <TableCell>Distrito</TableCell>
                    <TableCell>Referencia</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Giro negocio</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {addresses.map((address, i) => {
                    return (
                      <TableRow key={i}>
                        <TableCell>
                          {i + 1}
                          <AllowedGuard
                            permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_UPDATE}
                          >
                            <Button
                              justIcon
                              round
                              simple
                              color={props.themeContext.buttonColorWarning}
                              size="sm"
                              className={classes.marginRight}
                              onClick={() => {
                                if (bPartner.CardType === 'C') {
                                  setShowModal(true);
                                  setAddressId(address.id);
                                } else {
                                  setOpen(address);
                                }
                              }}
                            >
                              <Edit className={classes.icons} />
                            </Button>
                          </AllowedGuard>
                          <AllowedGuard
                            permission={
                              ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_BUSINESS_LINE_SHOW
                            }
                          >
                            <Button
                              justIcon
                              round
                              simple
                              color={props.themeContext.buttonColor}
                              size="sm"
                              className={classes.marginRight}
                              onClick={() => {
                                setShowModalBTurn(true);
                                setAddressId(address.id);
                              }}
                            >
                              <Business className={classes.icons} />
                            </Button>
                          </AllowedGuard>
                          {/* <Button
                            justIcon
                            round
                            color={props.themeContext.buttonColorDanger}
                            size="sm"
                            className={classes.marginRight}
                          >
                            <DeleteIcon className={classes.icons} />
                          </Button> */}
                        </TableCell>
                        <TableCell>{address.domicilio_id}</TableCell>
                        <TableCell>{address.AdresType === 'S' ? 'Entrega' : 'Fiscal'}</TableCell>
                        <TableCell>{address.Address2}</TableCell>
                        <TableCell>{address.base_ubigeo_Code}</TableCell>
                        <TableCell>{address.U_SYP_DEPA}</TableCell>
                        <TableCell>{address.U_SYP_PROV}</TableCell>
                        <TableCell>{address.U_SYP_DIST}</TableCell>
                        <TableCell>{address.adress_reference}</TableCell>
                        <TableCell>{address.state === 'A' ? 'Activo' : 'Inactivo'}</TableCell>
                        <TableCell>{address.business_line_default || '-'}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
      </GridItem>
    </LayerProvider>
  );
});
